import { createContext, useContext } from "react";
import type { AuthState } from "./AuthContext";

/**
 * Contesto e hook della sessione, separati dal provider (AuthContext.tsx): un
 * file che esporta componenti deve esportare solo componenti, altrimenti il
 * fast refresh di Vite non può sostituirlo a caldo.
 */
export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
